export enum SkeletonType {
  Browse = 1,
  Profile = 2,
}
